// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const StyledGridWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	padding: 5px;
	background-color: ${({ theme: { colors } }) => colors.whiteTrue};
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.element};

	${({ disable }) =>
		disable &&
		css`
			background-color: transparent;
		`}
`;

// #####################################################
